import React, { createContext, useContext } from 'react';
// Extend with any other app environments needed.

var AppNameContext = /*#__PURE__*/createContext('other');
function AppNameContextProvider(_ref) {
  var appName = _ref.appName,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(AppNameContext.Provider, {
    value: appName
  }, children);
}
function useAppNameContext() {
  return useContext(AppNameContext);
}
export { AppNameContextProvider, useAppNameContext };